//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';

import mdAutocomplete from '../../../../shared-components/autocomplete/mdAutocomplete';
import { removeParametrosNulos, prepareResponseData } from '../../../../common/functions/http';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import tabelaCommonsMixin from '../../../../shared-components/generico/tabelaCommonsMixin';

export default {
  mixins: [tabelaCommonsMixin],
  components: {
    Paginate,
    mdAutocomplete,
  },
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true,
    },
    isSearchAvailable: {
      type: Boolean,
      default: true,
    },
    tableHeader: Array,
  },
  computed: {
    ...generateComputed('Sellin', [
      'canImport',
      'canExport',
    ]),
  },
  watch: {
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.paginationPage = 0;
        this.filterDatasource();
      }, 500);
    },
  },
  data() {
    return {
      sellInResources: this.$api.sellIn(this.$resource),
      competenciaExportacao: null,
      competenciaExportacaoValor: null,
      blockExportButton: false,

      openSearchToolbar: false,
      searchQuery: '',
      sortData: { name: 'dessert', type: 'desc' },
      periodos: [],
    };
  },
  methods: {
    prepareResponseData,
    setCompetenciaExportacao(hit) {
      this.competenciaExportacao = hit.mesAno;
      this.competenciaExportacaoValor = hit.anoMes;
    },
    buscarPeriodos(filtro) {
      const parametros = Object.assign({ }, filtro, { size: 5, page: 0 });
      removeParametrosNulos(parametros);
      return this.sellInResources.periodos(parametros);
    },
    toggleImportacao() {
      this.$emit('SELLINTABELACONSOLIDADO_TOGGLE_IMPORTACAO');
    },
    fechaModalExportacao() {
      this.blockExportButton = false;
      this.$refs.modalExportacao.close();
      this.competenciaExportacao = null;
      this.competenciaExportacaoValor = null;
    },
    exportarSellIn() {
      this.blockExportButton = true;
      this.$emit('TABELAGENERICA_EXPORTAR_DADOS', this.competenciaExportacaoValor, this.fechaModalExportacao);
    },
    onSort(obj) {
      this.sortData = obj;
      this.$emit('TABELAGENERICA_ORDENAR', this.sortData);
    },
    closeSearchHeader() {
      this.searchQuery = '';
      this.openSearchToolbar = false;
    },
    focusSearchInput(id) {
      this.openSearchToolbar = true;
      setTimeout(() => {
        const input = document.getElementById(id);
        input.focus();
      }, 100);
    },
    filterDatasource() {
      this.showLoading = true;
      this.paginationPage = 1;

      const pagination = {
        size: this.limitePagina,
        page: this.paginationPage,
        filter: this.searchQuery,
      };

      removeParametrosNulos(pagination);

      this.$emit('TABELAGENERICA_BUSCAR_PROXIMA_PAGINA', pagination, this.closeLoading);
    },
    detalharConsolidado(row) {
      this.$emit('SELLINTABELACONSOLIDADO_DETALHAR', row);
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-in/SellinTabelaConsolidado.vue?vue&type=script&lang=js&